import { FC, KeyboardEvent, MouseEvent } from 'react';
import { IoInformationCircleOutline } from 'react-icons/io5';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Style from './styles';

type ResaleFeeInfoButtonProps = {
  /** Opens the "Entenda as taxas" modal. Receives the button itself so focus returns to it. */
  onOpen: (trigger: HTMLButtonElement) => void;
  id?: string;
};

/**
 * Icon-only button that opens the fees modal.
 *
 * Sits in the accordion row as a sibling of the ticket-select button
 * (never inside it), above the `::after` that covers the row. Click and
 * keyboard still stop propagation here as a safeguard: opening the modal
 * must never select the group or toggle the accordion.
 */
const ResaleFeeInfoButton: FC<ResaleFeeInfoButtonProps> = ({ onOpen, id }) => {
  const { translate } = useI18nContext();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onOpen(event.currentTarget);
  };

  // The browser turns Enter/Space on the button into a "click"; keydown doesn't
  // bubble up to any ancestor with a keyboard shortcut.
  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    event.stopPropagation();
  };

  return (
    <Style.Button
      type="button"
      id={id}
      aria-label={translate(['RESALE_LISTING', 'FEES_INFO_LABEL'])}
      aria-haspopup="dialog"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <IoInformationCircleOutline aria-hidden="true" focusable="false" />
    </Style.Button>
  );
};

export { ResaleFeeInfoButton };
